import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteRankingsSnapshot,
  getRankingsByEvent,
  patchRanking,
  setRankingsByEvent,
} from "./rankings.service";

const rankingsKey = "jeep-rally-rankings";

export const useGetRankingsByEvent = (
  eventId,
  params = {},
  options = {}
) => {
  const type = params?.type || params?.typeId || params?.type_id || "";
  const categoryId =
    params?.categoryId || params?.category_id || params?.category || "";
  const afterStage =
    params?.after_stage === 0 || params?.after_stage
      ? String(params.after_stage)
      : "";

  return useQuery({
    queryKey: [rankingsKey, eventId, type, categoryId, afterStage],
    queryFn: () => {
      const query = {
        type,
        categoryId,
      };
      if (afterStage !== "") {
        query.after_stage = Number(afterStage);
      }
      return getRankingsByEvent(eventId, query);
    },
    enabled:
      Boolean(eventId) &&
      Boolean(type) &&
      Boolean(categoryId) &&
      options.enabled !== false,
    ...options,
  });
};

export const useSetRankingsMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ eventId, payload }) =>
      setRankingsByEvent(eventId, payload),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [rankingsKey] });
      if (variables?.eventId) {
        queryClient.invalidateQueries({
          queryKey: [rankingsKey, variables.eventId],
        });
      }
    },
  });
};

export const usePatchRankingMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ rankingId, payload }) =>
      patchRanking(rankingId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [rankingsKey] });
    },
  });
};

export const useDeleteRankingsSnapshotMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ eventId, params }) =>
      deleteRankingsSnapshot(eventId, params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [rankingsKey] });
      if (variables?.eventId) {
        queryClient.invalidateQueries({
          queryKey: [rankingsKey, variables.eventId],
        });
      }
    },
  });
};
